import { ScriptDef, ScriptTheme } from '../../types';

export const WEB_SCRIPTS: ScriptDef[] = [
    {
        // 新手专属剧（2026-10-29 重写，旧《临时女主角》弃——文案定位不符）：《千金不换》=市场常见的小成本劣质网剧
        // （重生复仇打脸套路，4~5 分档）。三个女角色全部免试镜开放给玩家，按开局咖位三档发
        // （1~2 发女配角 / 3~4 发女二号 / 5 发女主角，DirectSignSystem.issueFirstOffer 匹配）；
        // 玩家没签的角色照常 sweepUnclaimedRoles 派 NPC。不进排期表，第一年一月签约当月直拍。
        id: 'SCRIPT_T01',
        name: '千金不换',
        genre: 'web',
        synopsis: '温氏集团独女温念初，前世在订婚宴上把名下股权当聘礼许了寒门未婚夫许崇礼，三年后被他和闺蜜孟霜降联手做局掏空公司，丧生于一场蹊跷的车祸。一觉醒来回到订婚宴当晚，她当众退婚，第二天带着律师团敲开了霍氏集团的大门。这一世，股权、公司、家产，她一样一样拿回来。剧组赶在开机前把最后几个角色定满，你来得不早不晚。',
        roles: [
            {
                name: '温念初',
                roleType: '女主角',
                billing: 1,
                intro: '温氏集团独女。前世在订婚宴上把股权当聘礼送了人，三年后丧生于一场夺产的车祸。重生回订婚宴当晚，她当众退了婚，第二天带着律师团去了霍氏。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '霍靳琛',
                roleType: '男主角',
                billing: 1,
                intro: '霍氏集团总裁。三年前温氏资金链告急，他递过一份收购案，被温念初当场撕掉。这一世温念初主动找上门，他把条款开得比谁都狠，但每一单都接了。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '孟霜降',
                roleType: '女二号',
                billing: 2,
                intro: '温念初的大学闺蜜，毕业后进温氏做了她的特别助理。前世她和许崇礼才是真的一对，温念初出殡那天，两人戴着婚戒见了媒体。这一世她照旧陪在温念初身边，只等订婚宴那杯酒。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '许崇礼',
                roleType: '男二号',
                billing: 2,
                intro: '寒门出身的项目经理，订婚宴上给温念初念了三页手写的誓词。前世他靠这场婚事进了温氏董事会，把岳家的公司一层层掏空。这一世誓词还在，温念初没听完。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '许盈盈',
                roleType: '女配角',
                billing: 3,
                intro: '许崇礼的妹妹，短视频平台上小有名气的探店博主。哥哥订下豪门婚事，她没过门就自封温家二小姐，出门必报「温氏未来少奶奶」的名号。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 2,
                attributeGrowth: { charm: 3 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Romance, ScriptTheme.Idol],
        heat: 33,
        baseScore: 4.6,
    },
    {
        id: 'SCRIPT_026',
        name: '偏航降落',
        genre: 'web',
        synopsis: '讲述了严谨到有些强迫症的航空管制员陆星辞，与随性洒脱、脑洞清奇的独立插画师夏初，因一场突如其来的雷暴天气在机场滞留而意外结缘的故事。夏初为了画一部航空题材的绘本，死皮赖脸地申请进塔台采风，而陆星辞也在夏初天马行空的画笔下，逐渐卸下了常年紧绷的神经。两人在一次次"偏航"的试探与靠近中，不仅治愈了彼此的生活，也迎来了属于他们的精准降落。',
        roles: [
            {
                name: '陆星辞',
                roleType: '男主角',
                billing: 1,
                intro: '空管中心最年轻的带班主任，行走的"人形雷达"。外表清冷禁欲，衬衫永远扣到最上面一颗，实则是个会在家里偷偷给流浪猫搭窝的闷骚男。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '夏初',
                roleType: '女主角',
                billing: 1,
                intro: '自由插画师，重度拖延症患者兼路痴。看似没心没肺、大大咧咧，实则心思细腻，能用色彩敏锐捕捉到陆星辞藏在冷漠下的温柔。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, talent: 2, temperament: 2 },
            },
            {
                name: '林亦舟',
                roleType: '男二号',
                billing: 2,
                intro: '陆星辞的同事兼大学室友，资深"吃瓜群众"与僚机。表面是风流倜傥的飞行员，背地里却是个重度二次元，暗恋夏初的闺蜜。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '林晚晚',
                roleType: '女二号',
                billing: 2,
                intro: '陆星辞的学妹兼公关总监，亦是他的大学女友。她认定那段感情只是被异地打断，带着复合的心思回到他身边，把夏初当成需要打发的新鲜意外。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, wisdom: 2 },
            },
            {
                name: '米乐',
                roleType: '女配角',
                billing: 4,
                intro: '塔台见习管制员，耳机里听到陆星辞的名字会紧张到报错风向。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { charm: 2, talent: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Idol, ScriptTheme.Romance, ScriptTheme.Occupation],
        heat: 48,
        baseScore: 6.8,
    },
    {
        id: 'SCRIPT_027',
        name: '时差恋人',
        genre: 'web',
        synopsis: '讲述了患有重度失眠症的冷面投行高管傅寒声，意外绑定了一个只能在午夜十二点到凌晨三点之间出现的"时差少女"苏念念。苏念念是个生活在十年前的元气电台主播，两人通过一台老式收音机跨越时空展开了一段限时同居。在日复一日的深夜陪伴中，傅寒声被苏念念的鲜活生命力治愈，而苏念念也发现了傅寒声冷漠外表下深藏的遗憾，两人携手打破时间的壁垒，只为在同一个时空里拥抱彼此。',
        roles: [
            {
                name: '傅寒声',
                roleType: '男主角',
                billing: 1,
                intro: '杀伐果断的投行大佬，常年靠黑咖啡续命的"失眠症患者"。眼神里总是带着疏离感，直到遇见苏念念，才学会了如何笨拙地表达偏爱。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, wisdom: 2, charm: 2 },
            },
            {
                name: '苏念念',
                roleType: '女主角',
                billing: 1,
                intro: '十年前的深夜电台主播，像一颗小太阳般温暖治愈。虽然身处过去，却用乐观和勇敢，一点点照亮了傅寒声灰暗的世界。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, talent: 2, temperament: 2 },
            },
            {
                name: '沈星河',
                roleType: '男二号',
                billing: 2,
                intro: '苏念念的青梅竹马，温柔腹黑的天才医生。一直默默守护着苏念念，是傅寒声在追妻路上最大的"醋意催化剂"。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { wisdom: 3, charm: 2 },
            },
            {
                name: '白芷',
                roleType: '女二号',
                billing: 2,
                intro: '傅寒声的联姻未婚妻，优雅矜贵的财阀千金。不仅对傅寒声并无感情，还暗中保护苏念念，最终体面解除婚约，转身搞事业。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Idol, ScriptTheme.Romance, ScriptTheme.Fantasy],
        heat: 50,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_028',
        name: '厉总的专属小甜妻',
        genre: 'web',
        synopsis: '讲述了初入职场的元气少女林小鹿，因一场意外与冷面总裁厉寒霆结下不解之缘。为了偿还债务，林小鹿被迫签下"贴身助理"契约，开启了鸡飞狗跳的同居生活。在相处中，霸道总裁厉寒霆逐渐被林小鹿的单纯善良所吸引，不仅为她扫清一切职场障碍，更频频上演壁咚、强吻的桥段。两人在经历了恶毒女配的陷害与家族逼婚等一系列考验后，最终解开误会，在豪华游轮上举行了盛大婚礼，甜蜜相拥。',
        roles: [
            {
                name: '厉寒霆',
                roleType: '男主角',
                billing: 1,
                intro: '掌控全球经济命脉的千亿总裁，外表冷酷无情，实则深情专一。他的世界里原本只有工作，直到遇见林小鹿，他甘愿化身护花使者，为她包揽一切。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '林小鹿',
                roleType: '女主角',
                billing: 1,
                intro: '初入职场的实习生，性格单纯善良，自带迷糊属性。虽然在职场上频频闯祸，但她真诚乐观的性格总能化险为夷，并成功俘获总裁的芳心。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '程敬',
                roleType: '男二号',
                billing: 2,
                intro: '厉寒霆最得力的助手，忠诚可靠且极具眼力见。他不仅是总裁工作上的左膀右臂，更是男女主感情升温路上的得力帮手。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2 },
            },
            {
                name: '苏曼曼',
                roleType: '女二号',
                billing: 2,
                intro: '厉寒霆的青梅竹马，出身名门的富家千金。她深爱厉寒霆，对林小鹿的出现充满敌意，屡次设下陷阱试图拆散两人，却总是弄巧成拙。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, talent: 2 },
            },
            {
                name: '前台',
                roleType: '女配角',
                billing: 5,
                intro: '总裁楼下前台，替厉寒霆收了三次花。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Idol, ScriptTheme.Romance],
        heat: 26,
        baseScore: 3.2,
    },
    {
        id: 'SCRIPT_029',
        name: '一年到期，概不退换',
        genre: 'web',
        synopsis: '落魄千金夏晚晴为替父还债，与冷面财阀顾夜琛签下为期一年的契约婚姻。婚后她以"顾太太"的身份住进顾家，笨拙适应新生活，而顾夜琛也在日复一日的相处中，被这个倔强又温暖的女孩打动。从互相防备到彼此依赖，两人在假千金回归、家族长辈施压等考验后撕毁契约，在雪山城堡中许下真正的誓言——这一次，没有期限，概不退换。',
        roles: [
            {
                name: '顾夜琛',
                roleType: '男主角',
                billing: 1,
                intro: '顾氏地产帝国掌舵人，商界公认的"冷面阎王"。自幼在豪门倾轧中长大，习惯用冷漠武装自己，将所有人拒之门外。直到夏晚晴闯入他的世界，他才发现，原来冰冷的生活也可以被一个人的笑容融化。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '夏晚晴',
                roleType: '女主角',
                billing: 1,
                intro: '曾经的豪门千金，因家族变故一夜之间跌落谷底。外表柔弱，骨子里却有着不服输的韧劲。她带着满腔孤勇踏入顾家，用真诚和善良一点点叩开了顾夜琛封闭的内心。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '陆亦白',
                roleType: '男二号',
                billing: 2,
                intro: '顾夜琛的发小兼私人医生，性格温和毒舌，是顾夜琛身边唯一能说上话的人。他最早察觉到顾夜琛对夏晚晴态度的变化，默默充当两人之间的"催化剂"。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { wisdom: 2, talent: 2 },
            },
            {
                name: '白若雪',
                roleType: '女二号',
                billing: 2,
                intro: '顾夜琛的青梅竹马，出身书香世家，温婉端庄，是外界公认的"顾太太最佳人选"。她深爱顾夜琛多年，面对夏晚晴的出现，从隐忍克制到步步紧逼，最终在执念中迷失了自己。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
            {
                name: '小柯',
                roleType: '男配角',
                billing: 5,
                intro: '顾宅门岗，台词就一句："顾先生，车备好了。"',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Idol, ScriptTheme.Romance],
        heat: 37,
        baseScore: 4.5,
    },
    {
        id: 'SCRIPT_030',
        name: '急诊室白月光',
        genre: 'web',
        synopsis: '急诊科住院医师温以宁在母亲被债逼至绝路时，遇到正被家族联姻逼得焦头烂额的霍氏继承人霍云深，两人各取所需闪电领证。婚后她白天穿梭在急诊室的生死之间，晚上面对豪门暗涌；霍云深表面漫不经心，却在不知不觉中习惯了每天去医院门口等她下班。两人从一场交易开始，在豪门争产、前未婚妻回国搅局等风波中并肩作战，最终在集团年会上当众相拥。',
        roles: [
            {
                name: '霍云深',
                roleType: '男主角',
                billing: 1,
                intro: '霍氏集团唯一继承人，外表玩世不恭，实则心思缜密。在家族内斗的漩涡中长大，早已学会用纨绔伪装自己。温以宁的出现，让他第一次想要卸下伪装，做一个真实的自己。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, wisdom: 2 },
            },
            {
                name: '温以宁',
                roleType: '女主角',
                billing: 1,
                intro: '急诊科住院医师，冷静果敢，见惯了生死，有着远超同龄人的坚韧与担当。她本无意踏入豪门，却在命运的推波助澜下，一步步走进了霍云深的世界，也走进了他的心里。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
            {
                name: '宋知行',
                roleType: '男二号',
                billing: 2,
                intro: '温以宁的大学同学兼同科室医生，温润内敛，多年来默默守护在温以宁身边。他是温以宁最信赖的朋友，也是这段婚姻中最令人心疼的旁观者。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { wisdom: 2, temperament: 2 },
            },
            {
                name: '赵思琪',
                roleType: '女二号',
                billing: 2,
                intro: '温以宁的急诊科同事，分诊台护师。她是全科室第一个发现温以宁“闪婚”的人，八卦归八卦，替她顶夜班、挡带教从不手软——全剧唯一知道温以宁婚后真实生活的同事。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2 },
            }
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Idol, ScriptTheme.Romance, ScriptTheme.Occupation],
        heat: 38,
        baseScore: 4.7,
    },
    {
        id: 'SCRIPT_040',
        name: '光斑',
        genre: 'web',
        synopsis: '竺也跟着外婆生活，母亲在外地打工，一年回来一次。她习惯把不开心的事写在纸条上塞进课桌的裂缝里，从小学四年级塞到现在。高二文理分班，竺也分进了新班主任柳原所在的班，同班的傅正午是年级里最吵的那个人。傅正午不知从哪天起发现了课桌裂缝的秘密，从此那道裂缝里除了纸条，开始出现薄荷糖、热手贴和一句一句的回条。',
        roles: [
            {
                name: '竺也',
                roleType: '女主角',
                billing: 1,
                intro: '单亲家庭女孩，安静，成绩中上，习惯把心事写成纸条。她给母亲打电话永远只报喜，挂了电话会蹲在学校小卖部门口把没说的话说完。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, charm: 3, temperament: 2 },
            },
            {
                name: '傅正午',
                roleType: '男主角',
                billing: 1,
                intro: '同班同学，年级里最吵的人，篮球场和讲台两头跑。他回纸条的字迹故意写得歪歪扭扭，怕被认出来，全年级只有他一个人这么写字。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, charm: 3, temperament: 2 },
            },
            {
                name: '闻笛',
                roleType: '女二号',
                billing: 2,
                intro: '竺也的同桌前桌，家境优渥的转学生，敏感傲娇。她一度以为傅正午喜欢的是自己，把误会挑明那天，是她第一次主动跟竺也说了实话。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, talent: 2, temperament: 2 },
            },
            {
                name: '柳原',
                roleType: '男配角',
                billing: 3,
                intro: '新来的班主任，中年，离异，上课爱讲题外话。他是全年级第一个没把“早恋”这个词说出口的大人，在傅正午的周记上批过一句：同学之间，互相照应，很好。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
            {
                name: '吴双',
                roleType: '女配角',
                billing: 5,
                intro: '竺也的同班同学，永远在抄作业，永远抄错行。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Campus],
        heat: 57,
        baseScore: 8.6,
    },
    {
        id: 'SCRIPT_041',
        name: '选修课',
        genre: 'web',
        synopsis: '南方一所大学，广播系的郭年贫嘴，每学期挂两门必修，全宿舍轮流押着他补考复习；摄影系的席蔓是系学生会纪检部的，记他迟到名字记得最多。两人因为一门跨系选修课组队拍短片，把舍友金声和广播站主播阮晴洋也拖了进来，流水账一样过完一学年：短片拿了奖、暗恋被挑明、有人退部、有人决定转专业。学年末的散伙夜宵上，几个人约好明年再拍一部。',
        roles: [
            {
                name: '郭年',
                roleType: '男主角',
                billing: 1,
                intro: '广播系大二学生，贫嘴，全系活动都找他当主持。每学期挂两门必修，补考全靠宿舍几个人轮流押着复习。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2 },
            },
            {
                name: '席蔓',
                roleType: '女主角',
                billing: 1,
                intro: '摄影系学生，系学生会纪检部干事，记郭年迟到名字记得比谁都多。后来两人搭档拍短片，她当导演，他当制片。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, talent: 3, charm: 2 },
            },
            {
                name: '金声',
                roleType: '男二号',
                billing: 2,
                intro: '郭年的舍友，中文系学霸，考前突击全宿舍都指望他划重点。他自己只有一件事不会：拒绝别人。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { wisdom: 2, talent: 2, temperament: 2 },
            },
            {
                name: '阮晴洋',
                roleType: '女二号',
                billing: 2,
                intro: '席蔓的舍友，广播站晚间节目主播，声音治愈。下了播音间她话最少，全宿舍的事都是从别人嘴里听来的。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, charm: 2 },
            },
            {
                name: '林知秋',
                roleType: '男配角',
                billing: 5,
                intro: '研一学长，本科时是全楼的传奇，保研后仍住在宿舍区。谁的快递没取、谁的门禁卡丢了，他比驿站还清楚。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Campus, ScriptTheme.Comedy],
        heat: 59,
        baseScore: 8.9,
    },
    {
        id: 'SCRIPT_042',
        name: '慢自行车',
        genre: 'web',
        synopsis: '南方小镇，五个高中生靠三辆自行车驮着上下学，结成小团体，在毕业那年的课桌上刻下名字。高考后各奔东西：舒晚去了北京，晏驰去了省城，庄婧辍学打工，牛大川留镇接了家里的修车铺，还有一个出了国就断了联系。一场没说清的误会让群聊沉了十年，只剩逢年过节的点赞。十年后老校拆迁，几个人回镇上搬那张课桌，一路把当年的群聊一句一句捡了回来。',
        roles: [
            {
                name: '晏驰',
                roleType: '男主角',
                billing: 1,
                intro: '十七岁那年全镇骑车最快的少年，骑的却是三辆车里最慢的一辆。如今在省城一家小公司上班，每年过年回镇上，都会绕老校门骑一圈。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2 },
            },
            {
                name: '舒晚',
                roleType: '女主角',
                billing: 1,
                intro: '五人里当年唯一考去北京的，后来也是唯一不再参加聚会的。她回镇中学教语文的那年，正遇上绕着学校骑车的晏驰。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2 },
            },
            {
                name: '牛大川',
                roleType: '男二号',
                billing: 2,
                intro: '五人里唯一没离开小镇的，接手了家里的修车铺。三辆自行车这些年都归他修，铃铛他留了下来，车后来当废铁卖了。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, stamina: 2, talent: 2 },
            },
            {
                name: '庄婧',
                roleType: '女二号',
                billing: 2,
                intro: '团体里的大姐，当年每一次聚会都由她张罗，如今在镇上开美容院。群聊是她建的，最后也是她设的免打扰。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, charm: 2 },
            },
            {
                name: '小栓',
                roleType: '男配角',
                billing: 5,
                intro: '牛大川修车铺的学徒，会修自行车不会修摩托，天天挨骂，骂完老板请他吃饭。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Campus, ScriptTheme.LifeStyle],
        heat: 50,
        baseScore: 7.9,
    },
    {
        id: 'SCRIPT_043',
        name: '毕业倒计时',
        genre: 'web',
        synopsis: '临海一中高三（2）班，校花级学霸江初晴距离高考只剩三十天，班里转来插班生慕辰。两人从互看不顺眼到被迫结成“学习对子”，在三十天的倒计时里情愫暗生。期间楚楚因车祸失忆住院，醒来只记得慕辰；段景烁为照顾楚楚，耽误了自己的艺考。高考前夜，慕辰身份揭晓——他其实是休学一年重考的往届生，只为回到当初那个没有说出口的夏天。高考结束铃响，慕辰在全校师生面前向江初晴表白，广播里响起两个人的定情歌曲。',
        roles: [
            {
                name: '慕辰',
                roleType: '男主角',
                billing: 1,
                intro: '神秘插班生，白天上课晚上夜跑，每次考试都比江初晴高一分。他的课桌里锁着一个铁盒子，据说装着他失去的那一年，到毕业也没有人见到它打开。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, talent: 2, temperament: 2 },
            },
            {
                name: '江初晴',
                roleType: '女主角',
                billing: 1,
                intro: '年级第一，优雅端方，校服永远没有褶皱。她给慕辰整理了一本错题集，每页页脚画一个小太阳，三十天画满了三十个。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '楚楚',
                roleType: '女二号',
                billing: 2,
                intro: '慕辰的青梅竹马，车祸醒来后失忆，记忆停在两年前。她不认得班里的新同学，只认得慕辰，笃定两个人还在一起。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, charm: 2 },
            },
            {
                name: '段景烁',
                roleType: '男二号',
                billing: 2,
                intro: '楚楚的同班同学，艺考生。楚楚住院那一个月，他把画具搬进病房走廊对着病床画素描，错过了自己的省联考。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '徐朵朵',
                roleType: '女配角',
                billing: 5,
                intro: '三班的作业课代表，收作业时光看字迹就知道谁抄了谁的。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Campus, ScriptTheme.Romance],
        heat: 41,
        baseScore: 5.9,
    },
    {
        id: 'SCRIPT_054',
        name: '珠帘卷',
        genre: 'web',
        synopsis: '嫡女云初裳前世被继母设计、被未婚夫退婚，含恨而终。重生归来，她凭前世记忆步步为营：继母下毒，她早已调换杯盏；舅舅夺产，她提前更换地契。靖王世子慕容烨今生对她一见钟情，成为她复仇路上最坚实的后盾。复仇势如破竹：三个月斗倒继母，半年拿回家产，一年内仇人尽数伏法。大结局，云初裳与慕容烨大婚，满堂宾客齐声称赞嫡女贤德。',
        roles: [
            {
                name: '云初裳',
                roleType: '女主角',
                billing: 1,
                intro: '重生嫡女，前世记忆精确到时辰。她凭借对未来的预知，总能先人一步，将所有人的命运都掌握在自己手中。',
                // 2026-09-30 一二番同级修：与二番慕容烨同为 Lv.5（片酬同为 15 万）→ 一番升一级；
                // 门槛/成长按台账 §3~§4 Lv6 档重推（50/45/40、Σ8 = 3/3/2）；小成本 web 女一番基准即 Lv.6，回归档位表
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '慕容烨',
                roleType: '男配角',
                billing: 2,
                intro: '靖王世子，前世退婚的未婚夫，今生对她一见钟情。他手握重兵，是云初裳复仇路上最强大的助力，总能及时出现为她扫清障碍。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '青黛',
                roleType: '女二号',
                billing: 2,
                intro: '陪嫁丫鬟转正的义妹，前世被继母收买背叛女主，今生被女主一句“我信你”感化，从此忠心不二。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '云崇',
                roleType: '男配角',
                billing: 3,
                intro: '二叔，夺产主力，机关算尽的每一步棋都被女主预判。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Romance],
        heat: 43,
        baseScore: 5.7,
    },
    {
        id: 'SCRIPT_061',
        name: '凤归朝',
        genre: 'web',
        synopsis: '前朝末代帝姬孟瑶光七岁时国破家亡，被权臣沈崇收养改名沈瑶光。十年后她以沈家嫡女身份被送入东宫做太子良娣，一边替太子打理内务，一边暗中联络前朝旧部。在东宫她周旋于太子萧景珩、三皇子、太医顾怀安和侍卫霍铮之间，同时与嫡妹沈锦瑟争夺太子青睐。经历数轮宫闱风波后助太子登基，自己登上后位，国仇家恨一并了结。',
        roles: [
            {
                name: '沈瑶光',
                roleType: '女主角',
                billing: 1,
                intro: '前朝末代帝姬，七岁国破后被权臣沈崇收养改名。入宫做太子良娣，面上替太子打理内务，暗中联络前朝旧部。在东宫人缘极好，姐姐们遇事都愿意替她出头。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '萧景珩',
                roleType: '男主角',
                billing: 1,
                intro: '当朝太子，对沈锦瑟一见钟情。朝堂上沉稳持重，回到东宫便替她挡掉大半风波，把后宫的事安排得妥妥帖帖。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2 },
            },
            {
                name: '顾怀安',
                roleType: '男二号',
                billing: 2,
                intro: '太医院首席太医，开的方子连院正都挑不出毛病。每回来东宫请脉，药方换了什么只有他自己清楚。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
            {
                name: '沈锦瑟',
                roleType: '女二号',
                billing: 2,
                intro: '沈家嫡女，沈瑶光的嫡妹，与姐姐争夺太子青睐。性子急、出手快，对太子心思的揣摩比谁都深，只是还没学会把这份了解变成手段。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, talent: 2, temperament: 2 },
            },
            {
                name: '霍铮',
                roleType: '男配角',
                billing: 3,
                intro: '东宫侍卫统领，沉默寡言，刀法在东宫无人能及。危急关头总是第一个挡在沈瑶光身前。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { stamina: 3, temperament: 2 },
            },
            {
                name: '青宁',
                roleType: '女配角',
                billing: 5,
                intro: '沈瑶光的贴身小宫女，记性好，替姐姐传话一个字都不会差。宫里的路她跑得最熟，谁跟谁不对付她比谁都门清。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Court, ScriptTheme.Scheme],
        heat: 39,
        baseScore: 5.4,
    },
    {
        id: 'SCRIPT_066',
        name: '缚生咒',
        genre: 'web',
        synopsis: '上古神君墨珩为平魔乱，以「缚生咒」将九渊魔尊缚进自己心口，从此神魔同体、生死与共。三百年后，本该灰飞烟灭的魔尊残魂挣出咒外，躲进了灯油司一个小仙的命里——她叫谢无妄，天真爱笑，什么也不记得，只知道自己添的长明灯总比别家的亮。残魂一日不灭，咒火便一日烧着她的命。墨珩须赶在月满前把咒渡回己身，可这咒认暖不认冷，她笑得越欢，他靠得越近，那火就越舍不得烧。',
        roles: [
            {
                name: '谢无妄',
                roleType: '女主角',
                billing: 1,
                intro: '灯油司低阶小仙，添油、剪芯、擦灯座，混日子的手艺样样在行，攒了一罐子人间话本讲给谁听都不腻。她不知道，自己心口住着的，是那缕本该消亡的魔尊残魂。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2 },
            },
            {
                name: '墨珩',
                roleType: '男主角',
                billing: 1,
                intro: '上古神君，以心为牢、以咒缚魔。三百年来不曾一日松懈，偏在这个最不听话的小仙身上，破了他不动声色的心防。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 3, talent: 2 },
            },
            {
                name: '寂无',
                roleType: '男二号',
                billing: 2,
                intro: '墨珩座下掌刑罚的师弟，奉命日日守着谢无妄。守着守着，守出了私心——咒火烧的是她的命，他烧的却是自己的规矩：他想过瞒下渡咒的时辰，让师兄永远找不到她。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'charm', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, charm: 2, talent: 2 },
            },
            {
                name: '烛阴',
                roleType: '女二号',
                billing: 2,
                intro: '蛰伏三百年的魔界旧部，为迎回魔尊而不择手段。她要的从来不是谢无妄死，而是那个「活过来」的魔尊亲手撕碎神界。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'charm', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, charm: 2, talent: 2 },
            },
            {
                name: '扫尘',
                roleType: '男配角',
                billing: 5,
                intro: '司命殿洒扫童子，扫了三百年台阶，头一回见神仙低头走路。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Xianxia, ScriptTheme.Romance],
        heat: 60,
        baseScore: 7.4,
    },
    {
        id: 'SCRIPT_067',
        name: '问花不语',
        genre: 'web',
        synopsis: '花神云蘅不肯嫁人，把一封未寄出的婚书点化成灵，让纸鸢灵扶花替她上天界完婚——婚书在，灵便在；婚书烧了，灵便散。扶花就这样成了星官重霄名义上的道侣，日子过得鸡毛蒜皮又心照不宣。直到天君下旨，婚书须送司籍官处焚验存档，司籍亲赴星官府当众焚验。也是那晚，重霄把朱笔折了——验出灵体，扶花便要当庭消散；他索性抗旨，把司籍扣在了府里。直到云蘅游历归来要讨回婚书，这桩瞒了天君的假婚事，才到了要摊牌的时候。',
        roles: [
            {
                name: '扶花',
                roleType: '女主角',
                billing: 1,
                intro: '一封婚书所化的纸鸢灵，替不肯嫁的花神云蘅上天界完婚。她记得婚书上的每一个字，却不懂字里的意思——后来天界晚宴她替重霄挡了三杯酒，才头一回觉得，这张纸烧了有点可惜。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 3, talent: 2 },
            },
            {
                name: '重霄',
                roleType: '男主角',
                billing: 1,
                intro: '天界星官，掌历谱星图，云蘅婚约的对象本就是他。他早看出扶花是纸鸢灵，却一直没有声张。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 3, talent: 2 },
            },
            {
                name: '云蘅',
                roleType: '女二号',
                billing: 2,
                intro: '花神，婚书本主，逃婚游历三界的自在人。归来后她没急着收回婚书，先想把扶花接出星官府「过日子」——两个名字共用一段人生的姑娘，谁也没问过对方想不想换回来。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Xianxia, ScriptTheme.Romance, ScriptTheme.Comedy],
        heat: 60,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_068',
        name: '折星',
        genre: 'web',
        synopsis: '星辰神君长庚万年前失手打落天柱命星，自此被贬下界受罚。他在人间寻到那颗命星化成的少女璇玑，做起一桩买卖：她每替他折一颗星，他就替她挡一次灾。璇玑不知这买卖是长庚单方面的还债——那颗星本该落在她头上，是他当年失手。借到第十年，天命反噬，账要连本带利地收。',
        roles: [
            {
                name: '璇玑',
                roleType: '女主角',
                billing: 1,
                intro: '孤女，与星官长庚做寿数买卖，替他折星，换他挡灾。她把十年攒下的星屑串成灯挂在门口，数着灯过日子——亮一盏，长庚就欠她一年。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2 },
            },
            {
                name: '长庚',
                roleType: '男主角',
                billing: 1,
                intro: '被贬人间的星辰神君，璇玑口中的「买卖主」。他每收一颗她折的星，就替她挡一次死劫——这桩买卖本是他单方面的还债，账清之日，就是他灰飞烟灭之时。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 3, talent: 2 },
            },
            {
                name: '启明',
                roleType: '男二号',
                billing: 2,
                intro: '司命星君，掌诸星轮转的历谱，也是唯一看透这盘局的人。他想拦，却拦不住一个执意逆天的人。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
            {
                name: '璎珞',
                roleType: '女二号',
                billing: 2,
                intro: '长庚的同门师妹，万年来守着师门故址。她看着师兄一次次折寿换人，劝过也拦过，最后替他守住了那道天柱残碑。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Xianxia, ScriptTheme.Romance],
        heat: 45,
        baseScore: 5.5,
    },
    {
        id: 'SCRIPT_106',  // 低分反面教材·电视剧/低分剧
        name: '一剑霜寒',
        genre: 'web',
        synopsis: '改编自百万级销量经典仙侠游戏同名 IP。剑冢守墓一脉的最后弟子池雾，背着师父坟中的断剑下山；途中结识的大师兄容景澈，是替门派独守了十年剑心石的人；魔尊燕九息笑看霜寒七剑逐代解封，魔族公主卓晚莺一纸旧婚书上门认剑主。人魔约法崩坏在即，百万玩家的青春记忆站在山门口，这一次，四个人替他们自己拔剑。',
        roles: [
            {
                name: '池雾',
                roleType: '女主角',
                billing: 1,
                intro: '守墓人带大的剑派小弟子，背一把木质练剑，真剑她不敢抽，怕师父在坟里听见。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 3, stamina: 2 },
            },
            {
                name: '容景澈',
                roleType: '男主角',
                billing: 1,
                intro: '剑派大师兄，独自守剑心石十年，剑净话也净，门派名册里池雾的名字后头写着"二弟子"。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '燕九息',
                roleType: '男二号',
                billing: 2,
                intro: '魔族魔尊，见剑就笑，不抢不毁只帮解封，他说人要自己选命，魔也是。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, stamina: 2, wisdom: 2 },
            },
            {
                name: '卓晚莺',
                roleType: '女二号',
                billing: 2,
                intro: '魔族流亡公主，攥着两族祖辈定下的旧婚书上人间认婿，认到一半改了主意，要先看看那位背木剑的姑娘。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Xianxia, ScriptTheme.Idol, ScriptTheme.Romance],
        heat: 32,
        baseScore: 4.2,
    },
    {
        // 特殊剧本（剧情解锁型）内容本体：附表见 tables/SpecialScripts.ts（2026-10-06，数值暂定待茄子手调）
        id: 'SCRIPT_901',
        name: '颠倒姻缘',
        genre: 'web',
        synopsis: '上元灯夜，江南武馆的卖艺女柳惊蛰和进京完婚的侯府世子裴珩同船倾覆。再醒来，人换了身子。世子在她家武馆挨师傅的板子，从扎马步学起；她在侯府替他挡酒局、应付一纸婚约。两家人都觉得自家孩子大病一场后性情大变。太医说换不换得回来要看天意，两人只好商量好，替对方把日子过下去。',
        roles: [
            {
                name: '柳惊蛰',
                roleType: '女主角',
                billing: 1,
                intro: '武馆的独女，能在十张方桌上打一套拳，认字不多，账记得清。换了身子之后，她要学着当侯府的独苗：行礼的规矩比拳谱难背。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, eq: 1 },
            },
            {
                name: '裴珩',
                roleType: '男主角',
                billing: 1,
                intro: '侯府世子，进京完婚的路上翻了船。肩不能挑手不能提，进了武馆天天被师傅罚扎马步。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 25 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, charm: 1 },
            },
            {
                name: '李令仪',
                roleType: '女二号',
                billing: 2,
                intro: '永嘉郡主，裴珩的未婚妻，皇室养大的郡主。未婚夫性情大变，她第一个起疑，也第一个发现这位世子换了性子后反而顺眼起来。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 25 }],
                shootWeeks: 3,
                attributeGrowth: { charm: 2 },
            },
            {
                name: '柳震山',
                roleType: '男配角',
                billing: 3,
                intro: '武馆师傅，柳惊蛰的父亲。女儿大病之后拳法松了半分，他看在眼里，嘴上不说，罚扎马步的时辰翻了一倍。',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 2,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: ['npc_xulinhui'],
        themes: [ScriptTheme.Ancient, ScriptTheme.Comedy, ScriptTheme.Romance],
        heat: 100,
        baseScore: 7.2,
    },
];
